import styled, { css } from 'styled-components';
import { colors, MediaQuery } from '../../../theme/style-helpers';

export const AddDocumentsButton = styled.button`
    display: flex;
    gap: 16px;
    align-items: center;
    border: none;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: ${colors.BLACK};
    margin: 0;
    padding: 0;
    background: none;
    cursor: pointer;
    text-align: left;
    align-self: flex-end;

    &:hover{
        text-decoration: underline;
    }
`;

export const FormHeader = styled.div`
    display: grid;
    grid-auto-flow: row;
    row-gap: 20px;
`;

export const FromTitleContainer = styled.div`
    display: grid;
    grid-auto-flow: row;
    row-gap: 4px;
`;

export const FormTitle = styled.h3`
    margin: 0;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    color: ${colors.BLACK};
`;

export const FormInfo = styled.p`
    margin: 0;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: ${colors.BLACK};
`;

export const FormAlert = styled.p`
    margin: 0;
    font-weight: 500;
    font-size: 14px;
    line-height: 130%;
    color: ${colors.BLACK};
`;

export const AlertLabel = styled.span`
    color: ${colors.BRAND_ORANGE};
`;

export const AddDocumentsContainer = styled.form`
    padding: 24px 16px;
    border: 1px solid #FFAF89;
    display: grid;
    grid-auto-flow: row;
    row-gap: 24px;

    ${MediaQuery.medium(css`
        padding: 40px;
    `)};
`;

export const FormCTAContainer = styled.div`
    display: flex;
    justify-content: space-between;

    ${MediaQuery.medium(css`
        justify-content: flex-end;
        gap: 32px;
    `)};
`;

